import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { ISelectOption } from '../../form-master/components/select-field/select-field.interface';

export const months: List<ISelectOption> = List([
  {
    key: 'DATE.MONTH.JANUARY',
    value: 1,
  },
  {
    key: 'DATE.MONTH.FEBRUARY',
    value: 2,
  },
  {
    key: 'DATE.MONTH.MARCH',
    value: 3,
  },
  {
    key: 'DATE.MONTH.APRIL',
    value: 4,
  },
  {
    key: 'DATE.MONTH.MAY',
    value: 5,
  },
  {
    key: 'DATE.MONTH.JUNE',
    value: 6,
  },
  {
    key: 'DATE.MONTH.JULY',
    value: 7,
  },
  {
    key: 'DATE.MONTH.AUGUST',
    value: 8,
  },
  {
    key: 'DATE.MONTH.SEPTEMBER',
    value: 9,
  },
  {
    key: 'DATE.MONTH.OCTOBER',
    value: 10,
  },
  {
    key: 'DATE.MONTH.NOVEMBER',
    value: 11,
  },
  {
    key: 'DATE.MONTH.DECEMBER',
    value: 12,
  },
]);

export function monthsLocalized(
  _translateService: TranslateService
): List<ISelectOption> {
  return months.map(
    (month: ISelectOption): ISelectOption => {
      return {
        key: _translateService.instant(month.key),
        value: month.value,
        e2eId: `month-${month.value}`,
      };
    }
  ) as List<ISelectOption>;
}
